import { $regraEntidade, $regraAcao } from '@/custom-enum/regras-enum.js'

export default [
    {
        path: '/empresa-outros-produtos',
        name: 'usuario-empresa-listar-outros-produtos',
        meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: $regraEntidade.portal.outrosProdutos.empresa,
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: 'Empresa - Outros Produtos'
        },
        component: () =>
            import ('@/views/pages/outros-produtos/usuario-empresa/listagemOutrosProdutos.vue'),
    },
    {
        path: '/sesi-outros-produtos-cadastrar',
        name: 'usuario-sesi-inserir-outros-produtos',
        meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: $regraEntidade.portal.outrosProdutos.sesi,
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: 'Empresa - Inserir Outros Produtos',
            cadastrar: true
        },

        component: () =>
            import ('@/views/pages/outros-produtos/usuario-sesi/CadastrarOutrosProdutos.vue'),
    },
    {
        path: '/sesi-outros-produtos-editar',
        name: 'usuario-sesi-editar-outros-produtos',
        meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: $regraEntidade.portal.outrosProdutos.sesi,
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: 'Empresa - Editar Outros Produtos'
        },
        component: () => import ('@/views/pages/outros-produtos/usuario-sesi/EditarOutrosProdutos.vue'),
    }
]
